import { useClickOutside, useKeydown } from '@btime/react-hooks'
import React from 'react'

import { Absolute, Relative } from '../helpers/Position'
import { getOptionValue } from '../form/picker/_helpers'
import { hasValue } from '../../../../utils/helpers/value'
import { useLazyOptions } from '../../utils/helpers/options'
import IconText from '../presentation/IconText'
import LabelIconListItem from '../list/LabelIconListItem'
import Loading from '../helpers/Loading'
import Panel from '../structure/Panel'
import Separator from '../helpers/Separator'
import Text from '../presentation/Text'

const Dropdown = ({ label, size, color, bold, options, onChange, labelField, placement, ...props }) => {
  const wrapperRef = React.useRef()
  labelField = labelField || 'name'
  color = color || 'dark2'

  const [open, setOpen] = React.useState(false)
  const toggle = () => setOpen(!open)
  const onClose = () => setOpen(false)
  // TODO: Move to inside kiti package
  useClickOutside(wrapperRef, { action: onClose })
  useKeydown(wrapperRef, { keys: ['Escape'], action: onClose })

  let [{ localOptions, canLoadMore, loading }, fetchOptions, fetchMoreOptions] = useLazyOptions(options)
  React.useEffect(() => {
    if (open) fetchOptions()
  }, [open])

  return (
    <div className="dropdown" ref={wrapperRef}>
      <IconText
        label={label}
        iconRight="BsFillCaretDownFill"
        iconSize={0.6}
        gutter={0.3}
        color={color}
        onClick={toggle}
        size={size}
        bold={hasValue(bold) ? bold : true}
      />

      <Relative>
        {open && (
          <Absolute placement={placement || 'bottomLeft'}>
            <Panel
              padding="0"
              radius={0.3}
              borderColor="light3"
              shadow="dark4"
              maxHeight={16}
              scroll
              onScrollToBottom={fetchMoreOptions}
              minWidth={12}
            >
              {!loading && !localOptions?.length && (
                <Separator weight={2}>
                  <Text color="dark5">Nenhum item encontrado</Text>
                </Separator>
              )}

              {localOptions.map(option => (
                <LabelIconListItem
                  key={getOptionValue(option, labelField)}
                  label={getOptionValue(option, labelField)}
                  description={getOptionValue(option, 'description')}
                  icon={getOptionValue(option, 'icon')}
                  color="dark2"
                  hoverBgColor="light1"
                  onClick={() => {
                    onClose()
                    onChange(option)
                  }}
                  onScrollToBottom={fetchMoreOptions}
                  {...option}
                />
              ))}
              {!!loading && <Loading size="small" />}
            </Panel>
          </Absolute>
        )}
      </Relative>
    </div>
  )
}

export default Dropdown
